<script lang="ts" setup>
import { useSlots } from "vue";
const slots = useSlots();
</script>

<template>
  <div class="base-page">
    <div v-if="slots.sidebar" class="sidebar">
      <div class="content">
        <slot name="sidebar"></slot>
      </div>
    </div>
    <div class="scroll-panel">
      <div class="content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
